import script from "./MealPresetsView.vue?vue&type=script&setup=true&lang=js"
export * from "./MealPresetsView.vue?vue&type=script&setup=true&lang=js"

import "./MealPresetsView.vue?vue&type=style&index=0&id=e03a0ba0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e03a0ba0"]])

export default __exports__